import React from 'react';
import './minimal.css';

const PageHero = ({ eyebrow, title, subtitle, ctaLabel, ctaHref }) => {
  return (
    <section className="min-hero section">
      <div className="gn-container">
        {eyebrow && <div className="min-eyebrow">{eyebrow}</div>}
        <h1 className="min-title">{title}</h1>
        {subtitle && <p className="min-subtitle">{subtitle}</p>}
        {ctaLabel && ctaHref && (
          <div className="min-cta">
            <a className="btn btn-gn-primary" href={ctaHref}>{ctaLabel}</a>
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;


